import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";

const RequireAuth = ({ allowedRoles ,children }) => {
    const location = useLocation();
    const role = useSelector((state) => state.auth.role)?.[0];
    const isMeetingDocsReportRoute = location.pathname.includes("meeting-docs-report");
    const hasMeetingDocsReportAccess = ["Secretary", "Assistant Secretary"].includes(role?.roleName);

    if(!role){
        console.warn('No role found.')
        return <Navigate to="/unauthorized" replace state={{from: location}} />;
    }

    if (isMeetingDocsReportRoute && !hasMeetingDocsReportAccess) {
        return <Navigate to="/unauthorized" replace state={{ from: location }} />;
    }

    // restricted roles
    if(role.restricted){
        if(role.roleName === "Company Admin"){
            return children;
        }

        if(role.roleName === "Admin"){
            return children;
        }

        if (["MasterData", "work-flow/request-type"].some((path) => location.pathname.includes(path))) {
            return <Navigate to="/unauthorized" replace state={{ from: location }} />;
        }
        return children;
    }
    
    // custom roles
    if(location.pathname.includes("work-flow/request-type")){
        return <Navigate to="/unauthorized" replace state={{ from: location }} />;
    }
    
    if(location.pathname.includes("MasterData") && role.permissions){
        const pathSegment = location.pathname.split("/").pop(); 
        const hasAccess = role.permissions.some((single) =>
            single.permissionName === pathSegment || pathSegment === "Committee-config"
        );
        if(!hasAccess){
            return <Navigate to="/unauthorized" replace state={{ from: location }} />;
        }
    } 
    
    return children;
    // return allowedRoles.includes(role[0]) ? children : children;
    // .some(r => r.roleName === 
    // return allowedRoles.includes(role[0]) ? children : <Navigate to="/masterData" replace />;
};
export default RequireAuth;
